import React, { useMemo } from 'react'
import { Select, Icon } from '@st-operations/uikit/src/v2/index'

import { useModal } from '_hooks'
import Collapsible from '../../../event-feeds/query-panel/collapsible'
import Chip from '../chip'
import MultiSelectGroupedModal from '../multi-select-grouped-modal'

import './styles.scss'

const MultiSelectPanel = (
  {
    className,
    title = 'Options',
    availableOptions = [],
    availableOptionsGrouped = [],
    selectedOptions = [],
    activeOption,
    onSelectedOptionsChange,
    onActiveOptionChange,
    allOptionValue = 'all',
    extractValue,
    extractLabel,
    extractGroupKey,
    headerAddon,
    hideShowValue,
  },
  ref
) => {
  const modal = useModal(false)

  const notSelectedOptions = useMemo(
    () =>
      availableOptions.filter(
        (availableOption) =>
          !selectedOptions.find((currentOption) => currentOption.value === availableOption.value)
      ),
    [availableOptions, selectedOptions]
  )

  const handleSelectedOptionAdd = (option) => {
    if (option.value === allOptionValue) {
      onSelectedOptionsChange?.([option])
      return
    }
    onSelectedOptionsChange?.([
      ...selectedOptions.filter((option) => option.value !== allOptionValue),
      option,
    ])
  }

  const handleSelectedOptionRemove = (option) => {
    onSelectedOptionsChange?.([
      ...selectedOptions.filter((currentOption) => currentOption.value !== option.value),
    ])
  }

  const handleSelectedOptionRemoveAll = () => {
    onSelectedOptionsChange?.(undefined)
  }

  return (
    <Collapsible
      className={className}
      ref={ref}
      title={title}
      onOpenClick={modal.handleOpenModal}
      onDeleteAllClick={handleSelectedOptionRemoveAll}
      showDeleteAllButton={selectedOptions.length > 0}
      headerAddon={headerAddon}
    >
      <MultiSelectGroupedModal
        title={title}
        hideShowOnlySelectedGroups
        open={modal.isOpen}
        onClose={modal.handleCloseModal}
        optionsGrouped={availableOptionsGrouped}
        selectedOptions={selectedOptions}
        onSubmit={onSelectedOptionsChange}
        extractValue={extractValue}
        extractLabel={extractLabel}
        extractGroupKey={extractGroupKey}
        hideShowValue={hideShowValue}
      />
      <Select
        placeholder={
          <div className="multi-select-panel__placeholder-search">
            <Icon icon="search" type="outline" color="#3D3D3D" /> Quick search{' '}
          </div>
        }
        options={notSelectedOptions}
        isSearchable
        onChange={handleSelectedOptionAdd}
        useReactSelect
      />

      <Choose>
        <When condition={selectedOptions.length === 0}>
          <p className="multi-select-panel__empty-text">You haven&apos;t added any {title} yet.</p>
        </When>
        <Otherwise>
          <section className="multi-select-panel__selections">
            <div className="multi-select-panel__selections-header">
              <h2 className="multi-select-panel__selections-title">Selected {title}</h2>
            </div>
            <div className="multi-select-panel__chips">
              <For each="currentOption" index="index" of={selectedOptions}>
                <Chip
                  key={currentOption.value}
                  value={currentOption.label}
                  selected={activeOption?.value === currentOption.value}
                  index={index}
                  onRemove={() => handleSelectedOptionRemove(currentOption)}
                  onSelect={onActiveOptionChange}
                />
              </For>
            </div>
          </section>
        </Otherwise>
      </Choose>
    </Collapsible>
  )
}

export default React.forwardRef(MultiSelectPanel)
